const UPDATE = 'adminPhotos/actions/UPDATE';
const DELETE = 'adminPhotos/actions/DELETE';
const UPLOAD = 'adminPhotos/actions/UPLOAD';

export const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE:
      return action.payload;
    case UPLOAD:
      return {
	...state,
	large: [action.payload, ...state.large]
      };
    case DELETE:
      return {
	...state,
	large: state.large.filter((i) => i.image !== action.payload.image),
      };
    default:
      return state;
  }
}

export function updateAdminCoverPageImages() {
  return async (dispatch) => {
    const response = await fetch('/api/coverPageImages?franchiseId=none');
    const json = await response.json();
    dispatch({
      type: UPDATE,
      payload: json,
    });
  };
}

export function uploadCoverPageImage(image) {
  return async (dispatch) => {
    const body = new FormData();
    body.append('image', image);
    const response = await fetch('/api/admin/coverPageImages', {
      method: 'POST',
      body,
    });

    const json = await response.json();
    dispatch({
      type: UPLOAD,
      payload: json
    });
  };
}

export function deleteCoverPageImage(image) {
  return async (dispatch) => {
    const imageName = image.substring(image.lastIndexOf('/') + 1);
    await fetch(`/api/admin/coverPageImages?image=${encodeURIComponent(imageName)}`, {
      method: 'DELETE',
    });
    dispatch({
      type: DELETE,
      payload: {
	  image,
	  franchise: false,
      }
    });
  };
}
